const sushiswap = require("./sushiswap");
const quickswap = require("./quickswap");

const TOKEN_SYMBOL_TO_ADDRESS = {
  WMATIC: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
  WETH: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
  USDC: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
  USDT: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
  SUSHI: "0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a",
  QUICK: "0x831753dd7087cac61ab5644b308642cc1c33dc13",
  dQUICK: "0xf28164a485b0b2c90639e47b0f377b4a438a16b1",
  MAGIC: "0xd8ca34fd379d9ca3c6ee3b3905678320f5b45195"
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.USDC]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.USDT]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.WETH]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.WMATIC]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.QUICK]: 18,
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WETH;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WMATIC;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  PROTOCOLS: {
    sushiswap,
    quickswap,
  },
  NATIVE_TOKEN,
};
